import React, { useEffect, useState } from "react";
import { Dropdown } from "../components/Dropdown";
import { ShortAnswer } from "../components/ShortAnswer";
import { SubmitButton } from "../components/SubmitButton";
import { liff } from "@line/liff";
import "./style.css";
import RootLayout from "layouts/RootLayout";
import { Dialog, DialogTitle } from "@mui/material";
import CreatableSelect from "react-select/creatable";
import { getClinicList } from "apis/clinicService";

// 幼兒專責醫師加入狀態（per-child，存於 content.childes[]）
type PediatricianStatus = "joined" | "interested" | "not_interested" | "";
type ClinicInfo = { code: string; name: string; isManual: boolean } | null;
type KidData = {
    name: string;
    age: string;
    weight: string;
    primary_medical: string;
    vaccineReminder: boolean;
    pediatricianStatus: PediatricianStatus;
    pediatricianClinic: ClinicInfo;
    birthDate: { year: string; month: string; day: string };
};
type ClinicOption = { value: string; label: string };


const LIFF_ID = process.env.REACT_APP_PROFILE_LIFF_ID;
const FETCH_SUCCESS = 200;

//eucare jake.chen
// const updateProfileUrl = 'https://script.google.com/macros/s/AKfycbzQRGTNUqI8QBkYt-5C5smS5czCK8OMY7iAJwSfSmMHQjeQQdA-NNLG7J_2EEKHcjIt/exec'
// const deleteProfileUrl = 'https://script.google.com/macros/s/AKfycbyrix66wi0pge2ZC_zi_KLnj7ngu2pEjNjFb5oBJpJ30X_EDsRtn6zu_Nq5OYh1Odo_Iw/exec'

// twdata puppy
// const updateProfileUrl = 'https://script.google.com/macros/s/AKfycbwJ1cL-QqTZNLvD2H36QRrf2dMeWUH4gtMTOuiIm3o26NUf3hXvNG3CbS7g-e4vIbpE7g/exec'
// const deleteProfileUrl = 'https://script.google.com/macros/s/AKfycbyGg5j-_eJVnTA2gd5EmZVaOs-bT3OQFCASTzGHVvFlzCZkdDP3_BJuTnFRNeSJzQqLWg/exec'

// nest
const updateProfileUrl = process.env.REACT_APP_PROFILE_UPDATE_URL;
const deleteProfileUrl = process.env.REACT_APP_PROFILE_DELETE_URL;
const getAppProfileUrl = process.env.REACT_APP_PROFILE_GET_URL;


const initializeLIFF = async () => {
    try {
        await liff.init({ liffId: LIFF_ID });

        if (!liff.isLoggedIn()) {
            liff.login();
        }
        // if (!liff.isInClient()) {
        //     alert('基本資料請使用手機 LINE APP 開啟填寫，如您有緊急需求請撥打 119 或可參考下列就醫資訊詢問');
        //     window.location.href = "https://klbaby.gocare.tw/clinicList";   // dev
        //     return null;
        // }
        return liff;
    } catch (error: unknown) {
        console.error('初始化 liff 時出錯：', error);
    }
};


const Profile = (): JSX.Element => {
    const [liffClientObject, setLiffClientObject] = useState(null);
    // name of the user
    const [name, setName] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [loading, setLoading] = React.useState(true);
    const [kidscount, setKidscount] = useState(0);
    const [kidData, setKidData] = useState<KidData[]>([{
        name: '',
        age: '',
        weight: '',
        primary_medical: '',
        vaccineReminder: false,
        pediatricianStatus: '',
        pediatricianClinic: null,
        birthDate: { year: '', month: '', day: '' } // Changed from string to object
    }]);
    const [childCareClinics, setChildCareClinics] = useState<ClinicOption[]>([]);
    const [deleteBtn, setDeleteBtn] = useState(false);


    const userId = liffClientObject?.getContext()?.userId
    const accessToken = liffClientObject?.getAccessToken()



    useEffect(() => {
        const initialize = async () => {
            const liffObject = await initializeLIFF();
            setLiffClientObject(liffObject);
        };
        initialize()
    }, []);


    useEffect(() => {
        if (userId === undefined) return
        if (accessToken === undefined) return

        const getProfileUrl = `${getAppProfileUrl}${userId}?access_token=${accessToken}`;
        console.log('accessToken', accessToken);
        fetch(getProfileUrl)
          .then(response => response.json())
          .then(data => {
              if (data.status_code === FETCH_SUCCESS) {
                  setDeleteBtn(true);
                  setName(data.data.name);
                  setPhone(data.data.phone);
                  setAddress(data.data.address);
                  setKidscount(data.data.child_number);

                  // Process each child's data
                  const processedKidData = data.data.childes.map(child => {
                      // Initialize birthDate object
                      let birthDateObj = { year: '', month: '', day: '' };

                      // Parse birthDate string if it exists
                      if (typeof child.birthDate === 'string' && child.birthDate) {
                          const [year, month] = child.birthDate.split('-');
                          birthDateObj = {
                              year: year || '',
                              month: month ? String(parseInt(month, 10)) : '', // Remove leading zero
                              day: '' // Not showing day in UI
                          };
                      }
                      // Use existing object structure if already in correct format
                      else if (child.birthDate?.year) {
                          birthDateObj = child.birthDate;
                      }

                      return {
                          ...child,
                          vaccineReminder: child.vaccineReminder || false,
                          pediatricianStatus: child.pediatricianStatus || '',
                          pediatricianClinic: child.pediatricianClinic || null,
                          birthDate: birthDateObj
                      };
                  });

                  setKidData(processedKidData);
              } else {
                  setKidscount(1);
              }
              setLoading(false);
              console.log(data);
          });
    }, [userId, accessToken])

    // 載入幼兒專責機構診所清單（重用就醫資訊診所 API，篩 isChildCare）
    // 失敗時不阻斷表單，清單為空仍可於 CreatableSelect 自由輸入診所
    useEffect(() => {
        getClinicList()
          .then((list) => {
              const options: ClinicOption[] = (Array.isArray(list) ? list : [])
                .filter((c) => c && c.isChildCare)
                .map((c) => ({ value: c.code, label: c.name }));
              setChildCareClinics(options);
          })
          .catch(() => setChildCareClinics([]));
    }, [])


    const formRef = React.useRef<HTMLFormElement>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        setLoading(true);
        e.preventDefault();
        if (validate()) {
            // 幼兒專責醫師：選「有加入」必須選擇或輸入專責診所，避免「已加入但無診所」髒資料
            const invalidKid = kidData.findIndex(
                kid => kid.pediatricianStatus === 'joined' && !kid.pediatricianClinic?.name
            );
            if (invalidKid !== -1) {
                setLoading(false);
                alert(`孩子 ${invalidKid + 1}：已加入幼兒專責醫師，請選擇或輸入專責診所`);
                return;
            }

            if (liff) {
                console.log(await liff.getProfile());

                // Create a new array for submission without modifying kidData
                const formattedKidData = kidData.map(kid => {
                    // Create a new object for submission
                    const submissionKid = {
                        name: kid.name,
                        age: kid.age,
                        weight: kid.weight,
                        primary_medical: kid.primary_medical,
                        vaccineReminder: kid.vaccineReminder,
                        // normalize：僅 joined 帶診所，其餘狀態一律 null
                        pediatricianStatus: kid.pediatricianStatus || '',
                        pediatricianClinic: kid.pediatricianStatus === 'joined' ? kid.pediatricianClinic : null,
                        birthDate: ''
                    };

                    // Format birthDate only if vaccine reminder is enabled and year/month exist
                    if (kid.vaccineReminder &&
                      kid.birthDate?.year &&
                      kid.birthDate?.month) {
                        const year = kid.birthDate.year;
                        const month = String(kid.birthDate.month).padStart(2, '0');
                        // Always use '01' for the day
                        const day = '01';
                        submissionKid.birthDate = `${year}-${month}-${day}`;
                    }

                    return submissionKid;
                });

                await fetch(updateProfileUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body: JSON.stringify({
                        accessToken: accessToken,
                        profile: await liff.getProfile(),
                        userId: userId,
                        name: name,
                        phone: phone,
                        address: address,
                        child_number: kidscount,
                        childes: formattedKidData,
                    })
                }).then(async () => {
                    await liff.sendMessages([{
                        type: 'text',
                        text: '基本資料已儲存'
                    }]);
                }).catch((error) => {
                    alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!!');
                });
                liff.closeWindow();
            } else {
                console.error('LIFF client object is not initialized');
                alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!');
            }
        }
    };

    const handleDelete = async () => {
        const delConfirm = window.confirm('確定刪除資料嗎')

        if (!delConfirm) {
            alert('刪除取消')
            return;
        }
        setLoading(true);

        if (validate()) {
            if (liff) {
                await fetch(deleteProfileUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body: JSON.stringify({
                        accessToken: accessToken,
                        userId: userId,
                    })
                }).then(async () => {
                    await liff.sendMessages([{
                        type: 'text',
                        text: '基本資料已刪除'
                    }]);
                }).catch((error) => {
                    console.log(error);
                    // 顯示錯誤訊息提示，跳出訊息內容：因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119
                    alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!!');
                });
                setLoading(false);
                liff.closeWindow();
            } else {
                console.error('LIFF client object is not initialized');
                alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!');
            }
        }
    };

    const validate = () => {
        const form = formRef.current;
        if (form?.checkValidity()) {
            return true;
        } else {
            return false;
        }
    };

    const handleKidsNum = (e) => {
        const kidsNum = Number(e.target.value)
        setKidscount(kidsNum);

        // 保留相同位置的既有小孩資料，僅新增/截斷數量差異（避免誤改數量清空已填資料）
        setKidData(prev => Array.from({ length: kidsNum }, (_, i) => prev[i] ?? ({
            name: '',
            age: '',
            weight: '',
            primary_medical: '',
            vaccineReminder: false,
            pediatricianStatus: '',
            pediatricianClinic: null,
            birthDate: { year: '', month: '', day: '' } // Initialize as object
        })));
    }

    const handleKidsInput = (e, index, type) => {
        const temp = [...kidData];
        temp[index][type] = e.target.value;
        setKidData(temp);
    }

    const handleVaccineReminderChange = (index) => {
        const temp = [...kidData];
        temp[index].vaccineReminder = !temp[index].vaccineReminder;
        setKidData(temp);
    };

    const handleBirthDateChange = (index, type, value) => {
        const temp = [...kidData];
        // No need to check if birthDate exists since we've initialized it properly
        temp[index].birthDate = {
            ...temp[index].birthDate,
            [type]: value
        };
        setKidData(temp);
    };

    const handlePediatricianStatus = (index, status) => {
        const temp = [...kidData];
        temp[index].pediatricianStatus = status;
        // 非「有加入」時清空診所
        if (status !== 'joined') {
            temp[index].pediatricianClinic = null;
        }
        setKidData(temp);
    };

    const handleClinicChange = (index, option, meta) => {
        const temp = [...kidData];
        if (!option) {
            temp[index].pediatricianClinic = null;
        } else if (meta && meta.action === 'create-option') {
            // 清單找不到、自由輸入
            temp[index].pediatricianClinic = { code: '', name: option.label, isManual: true };
        } else {
            temp[index].pediatricianClinic = { code: option.value, name: option.label, isManual: false };
        }
        setKidData(temp);
    };

    return (
        <RootLayout title="基本資料">
            <form onSubmit={handleSubmit} ref={formRef} >
                <div style={{ display: 'flex', flexDirection: 'column', padding: '20px 44px', gap: '16px' }}>
                    <ShortAnswer className="" hasDiv={false} text="姓　　名："
                        dataInput={name}
                        disabled={loading}
                        onChange={(e) => {
                            setName(e.target.value);
                        }}
                    />

                    <ShortAnswer className="" hasDiv={false} text="聯絡電話："
                        dataInput={phone}
                        disabled={loading}
                        onChange={(e) => {
                            setPhone(e.target.value);
                        }}
                    />

                    <ShortAnswer className="" hasDiv={false} text="地　　址："
                        dataInput={address}
                        disabled={loading}
                        onChange={(e) => {
                            setAddress(e.target.value);
                        }}
                    />

                    <Dropdown
                        className=""
                        frame="/img/frame.svg"
                        frameClassName="dropdown-2"
                        hasDiv={false}
                        options={["1", "2", "3", "4", "5", "6", "7", "8"]}
                        dataSelected={String(kidscount)}
                        disabled={loading}
                        onChange={handleKidsNum}
                        text="家中孩子數量："
                    />

                    {Array.from({ length: kidscount }, (_, index) => (
                      <div key={index}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                              <h3
                                style={{
                                    color: '#555555',
                                    fontSize: '20px',
                                    fontWeight: 700,
                                }}
                              >
                                  孩子 {index + 1}
                              </h3>
                              <ShortAnswer
                                className=""
                                hasDiv={false}
                                text='孩子姓名：'
                                dataInput={kidData[index].name}
                                disabled={loading}
                                onChange={(e) => handleKidsInput(e, index, 'name')}
                              />
                              <ShortAnswer
                                className=""
                                hasDiv={false}
                                text="年　　齡："
                                dataInput={kidData[index].age}
                                disabled={loading}
                                onChange={(e) => handleKidsInput(e, index, 'age')}
                              />
                              <ShortAnswer
                                className=""
                                hasDiv={false}
                                text="體　　重："
                                dataInput={kidData[index].weight}
                                disabled={loading}
                                onChange={(e) => handleKidsInput(e, index, 'weight')}
                              />
                              <ShortAnswer
                                className=""
                                hasDiv={false}
                                text="平時主要就醫診所機構："
                                dataInput={kidData[index].primary_medical}
                                disabled={loading}
                                onChange={(e) => handleKidsInput(e, index, 'primary_medical')}
                              />
                              <label style={{ color: '#555555', fontSize: '20px', fontWeight: 'bold' }}>
                                  <input
                                    type="checkbox"
                                    checked={kidData[index]?.vaccineReminder || false}
                                    onChange={() => handleVaccineReminderChange(index)}
                                    disabled={loading}
                                  />
                                  疫苗施打提醒
                              </label>
                              <div style={{ color: '#555555', fontSize: '14px', fontWeight: 'normal' }}>
                                  本施打提醒需請提供孩子出生年月。
                              </div>
                              {kidData[index].vaccineReminder && (
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <Dropdown
                                      className=""
                                      frame="/img/frame.svg"
                                      frameClassName="dropdown-2"
                                      hasDiv={false}
                                      options={Array.from({ length: 18 }, (_, i) => String(new Date().getFullYear() - i))}
                                      dataSelected={kidData[index]?.birthDate?.year || ''}
                                      disabled={loading}
                                      onChange={(e) => handleBirthDateChange(index, 'year', e.target.value)}
                                      text="出生年："
                                    />
                                    <Dropdown
                                      className=""
                                      frame="/img/frame.svg"
                                      frameClassName="dropdown-2"
                                      hasDiv={false}
                                      options={Array.from({ length: 12 }, (_, i) => String(i + 1))}
                                      dataSelected={kidData[index]?.birthDate?.month || ''}
                                      disabled={loading}
                                      onChange={(e) => handleBirthDateChange(index, 'month', e.target.value)}
                                      text="出生月："
                                    />
                                </div>
                              )}

                              {/* 幼兒專責醫師加入狀態 */}
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                  <label style={{ color: '#555555', fontSize: '20px', fontWeight: 'bold' }}>
                                      是否已加入幼兒專責醫師：
                                  </label>
                                  <label style={{ color: '#555555', fontSize: '16px' }}>
                                      <input
                                        type="radio"
                                        name={`pediatrician-${index}`}
                                        checked={kidData[index].pediatricianStatus === 'joined'}
                                        onChange={() => handlePediatricianStatus(index, 'joined')}
                                        disabled={loading}
                                      />
                                      &nbsp;有加入
                                  </label>
                                  <label style={{ color: '#555555', fontSize: '16px' }}>
                                      <input
                                        type="radio"
                                        name={`pediatrician-${index}`}
                                        checked={kidData[index].pediatricianStatus === 'interested'}
                                        onChange={() => handlePediatricianStatus(index, 'interested')}
                                        disabled={loading}
                                      />
                                      &nbsp;未加入，我有興趣了解請與我聯絡
                                  </label>
                                  <label style={{ color: '#555555', fontSize: '16px' }}>
                                      <input
                                        type="radio"
                                        name={`pediatrician-${index}`}
                                        checked={kidData[index].pediatricianStatus === 'not_interested'}
                                        onChange={() => handlePediatricianStatus(index, 'not_interested')}
                                        disabled={loading}
                                      />
                                      &nbsp;未加入，我目前暫無意願
                                  </label>
                                  {kidData[index].pediatricianStatus === 'joined' && (
                                    <CreatableSelect
                                      isClearable
                                      placeholder="請搜尋診所文字"
                                      formatCreateLabel={(input) => `使用自由輸入：「${input}」`}
                                      noOptionsMessage={() => '查無診所，可直接輸入名稱'}
                                      isDisabled={loading}
                                      options={childCareClinics}
                                      value={
                                          kidData[index].pediatricianClinic
                                            ? {
                                                value: kidData[index].pediatricianClinic.code,
                                                label: kidData[index].pediatricianClinic.name,
                                            }
                                            : null
                                      }
                                      onChange={(option, meta) => handleClinicChange(index, option, meta)}
                                    />
                                  )}
                              </div>
                          </div>
                          {index < kidscount - 1 && (
                            <div
                              style={{
                                  height: '1px',
                                  backgroundColor: '#E0E0E0',
                                  margin: '12px 0',
                                  width: '100%'
                              }}
                            />
                          )}
                      </div>
                    ))}
                    <SubmitButton className="profileSubmitbtn" text="寫好送出" loading={loading}
                        disabled={loading}
                    />
                    {deleteBtn && <SubmitButton type="button" className="profileDeletebtn" onClick={handleDelete} text="刪除基本資料" />}
                </div>
            </form>

            <Dialog open={loading}>
                <DialogTitle >
                    資料存取中...
                </DialogTitle>
            </Dialog>
        </RootLayout>
    );
};

export default Profile;